import { create } from "zustand";
import { IUser } from "../types/models/user.models.types";

interface IUsersStore {
  data: IUser[];
  setData: (data: IUser[]) => void;
  removeById: (id: string) => void;
}

const useUsersStore = create<IUsersStore>((set) => ({
  data: [],
  setData: (data: IUser[]) => set(() => ({ data })),
  removeById: (id: string) =>
    set((state) => ({
      data: state.data.filter((user) => user.id !== id),
    })),
}));

export default useUsersStore;